export class HttpContextConfig {
  noSpinner?: boolean = false;
  isPublic?: boolean = false;
  isInitializer?: boolean = false;
}
